import { render, staticRenderFns } from "./DShareScormDownloadPopup.vue?vue&type=template&id=655c2586&scoped=true&"
import script from "./DShareScormDownloadPopup.vue?vue&type=script&lang=js&"
export * from "./DShareScormDownloadPopup.vue?vue&type=script&lang=js&"
import style0 from "./DShareScormDownloadPopup.vue?vue&type=style&index=0&id=655c2586&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655c2586",
  null
  
)

export default component.exports